import { CHAT_OPEN, CHAT_CLOSE, CHAT_TOGGLE, CHAT_SET_UNREAD_COUNT } from './types'

export const openChat = () => ({
  type: CHAT_OPEN
})

export const closeChat = () => ({
  type: CHAT_CLOSE
})

export const toggleChat = () => ({
  type: CHAT_TOGGLE
})

export const setChatUnreadCount = (count) => ({
  type: CHAT_SET_UNREAD_COUNT,
  payload: count
})